import { useEffect, useState } from 'react'

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import { Collapse, IconButton } from '@mui/material'
import { TableCellStyled, TableRowStyled, TableStyled } from 'components'
import { ItensConsolidacaoTurnOver } from 'services/NGT/EffectiveConsolidation'

interface ICollapsibleTable {
  row: ItensConsolidacaoTurnOver
  isGeneratePDF: boolean
}

export const CollapsibleTable = ({ row, isGeneratePDF }: ICollapsibleTable) => {
  const [open, setOpen] = useState(isGeneratePDF)

  useEffect(() => {
    if (isGeneratePDF) setOpen(true)
  }, [isGeneratePDF])

  return (
    <>
      <TableRowStyled>
        <TableCellStyled>
          {row?.itens.length > 0 && (
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          )}
        </TableCellStyled>
        <TableCellStyled width="200px">
          {row?.totalizadores.dsConsolidacao}
        </TableCellStyled>
        <TableCellStyled align="center">
          {row?.totalizadores.ativo}
        </TableCellStyled>
        <TableCellStyled align="center">
          {row?.totalizadores.demitido}
        </TableCellStyled>
        <TableCellStyled align="center">
          {row?.totalizadores.acesso}
        </TableCellStyled>
        <TableCellStyled align="center">
          {row?.totalizadores.transferido}
        </TableCellStyled>
        <TableCellStyled align="center">
          {row?.totalizadores.afastado}
        </TableCellStyled>
        <TableCellStyled align="center">
          {row?.totalizadores.compartilhado}
        </TableCellStyled>
        <TableCellStyled align="center">
          {row?.totalizadores.totalEfetivo}
        </TableCellStyled>
        <TableCellStyled align="center">
          {row?.totalizadores.qtTotalSemDemitido}
        </TableCellStyled>
        <TableCellStyled align="center">
          {row?.totalizadores.turnOver}%
        </TableCellStyled>
      </TableRowStyled>

      {/*  INICIO TABLE COLLAPSED */}
      <TableRowStyled style={{ display: !open && 'none' }}>
        <TableCellStyled style={{ padding: 0 }} colSpan={11}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <TableStyled>

              <TableRowStyled>
                <TableCellStyled colSpan={1} />
                <TableCellStyled align="center">Ativo</TableCellStyled>
                <TableCellStyled align="center">Demitido</TableCellStyled>
                <TableCellStyled align="center">Acesso</TableCellStyled>
                <TableCellStyled align="center">Transferido</TableCellStyled>
                <TableCellStyled align="center">Afastado</TableCellStyled>
                <TableCellStyled align="center">Compartilhado</TableCellStyled>
                <TableCellStyled align="center">Total</TableCellStyled>
                <TableCellStyled align="center">Sem Demitidos</TableCellStyled>
                <TableCellStyled align="center">% TurnOver</TableCellStyled>
              </TableRowStyled>

              {row?.itens.map((collapseRow, index) => (
                <TableRowStyled key={index}>
                  <TableCellStyled minwidth="200px">
                    {collapseRow?.dsConsolidacao}
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    {collapseRow?.ativo}
                  </TableCellStyled>

                  <TableCellStyled align="center">
                    {collapseRow?.demitido}
                  </TableCellStyled>

                  <TableCellStyled align="center">
                    {collapseRow?.acesso}
                  </TableCellStyled>

                  <TableCellStyled align="center">
                    {collapseRow?.transferido}
                  </TableCellStyled>

                  <TableCellStyled align="center">
                    {collapseRow?.afastado}
                  </TableCellStyled>

                  <TableCellStyled align="center">
                    {collapseRow?.compartilhado}
                  </TableCellStyled>

                  <TableCellStyled align="center">
                    {collapseRow?.totalEfetivo}
                  </TableCellStyled>

                  <TableCellStyled align="center">
                    {collapseRow?.qtTotalSemDemitido}
                  </TableCellStyled>

                  <TableCellStyled align="center">
                    {collapseRow?.turnOver}%
                  </TableCellStyled>
                </TableRowStyled>
              ))}
            </TableStyled>
          </Collapse>
        </TableCellStyled>
      </TableRowStyled>
    </>
  )
}
